module.exports = __webpack_public_path__ + "static/media/YM59_5.a1529a7e.jpg";